import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import FirstView from "../../Repeated-Component/FirstView";
import labResultImage from "../../../../../../../../assets/medical-record/requests/labResult.png";
import { connect } from "react-redux";
import { getLabResultList } from "../../../../../../../../store/actions";

import { useToast } from "@chakra-ui/react";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const ListingLabResult = ({ patient, getLabResultList, LabResultList }) => {
  const { url } = useRouteMatch();
  let query = useQuery().get("page");
  const toast = useToast();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [LabResult, setLabResult] = useState([]);
  const [filterLabResult, setFilterLabResult] = useState([]);
  const [currentPage, setCuttentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const pagesNumber = Math.ceil(totalResults / 15);

  const nextPage = () => {
    const next = currentPage + 1;
    history.push(`${url}?page=${next}`);
  };

  const prevPage = () => {
    const prev = currentPage - 1;
    history.push(`${url}?page=${prev}`);
  };

  const specificPage = (pageNum) => {
    history.push(`${url}?page=${pageNum}`);
  };
  useEffect(() => {
    getLabResultList(toast, history, patient.id, query);
  }, [getLabResultList, query]);

  useEffect(() => {
    if (LabResultList) {
      const { loading, error, data } = LabResultList;
      setLoading(loading);
      setError(error);
      if (data) {
        setLabResult(data.data);
        setFilterLabResult(data.data);
        setTotalResults(data.meta.total);
        setCuttentPage(data.meta.current_page);
      }
    }
  }, [LabResultList]);

  return (
    <div>
      <FirstView
        loading={loading}
        error={error}
        headerName="Lab Result"
        buttonLink={`${url}/request-lab_result`}
        cardLink={`${url}/view-lab_result`}
        data={LabResult}
        filterData={filterLabResult}
        setFilter={setFilterLabResult}
        conditionImage={labResultImage}
        pages={pagesNumber}
        nextPage={nextPage}
        prevPage={prevPage}
        specificPage={specificPage}
        currentPage={currentPage}
        totalResults={totalResults}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    LabResultList: state.LabResultList,
  };
};
export default connect(mapStateToProps, { getLabResultList })(ListingLabResult);
